import { ChakraStylesConfig } from 'chakra-react-select';

import { outline } from './outline';
import { solid } from './solid';
import { fullSolid } from './fullSolid';
import { roundedViolet } from './roundedViolet';
import { roundedVioletClosable } from './roundedVioletCloseable';
import { roundedGreenClosable } from './roundedGreenClosable';
import { roundedGray } from './roundedGray';
import { outlineBig } from './outlineBig';
import { solidWhite } from './solidWhite';

export type VariantsAvailable =
  | 'outline'
  | 'outlineBig'
  | 'solid'
  | 'fullSolid'
  | 'roundedGreenClosable'
  | 'roundedViolet'
  | 'roundedVioletClosable'
  | 'roundedGray'
  | 'solidWhite';

export const variants: Record<VariantsAvailable, ChakraStylesConfig> = {
  outline,
  outlineBig,
  solid,
  fullSolid,
  roundedGreenClosable,
  roundedGray,
  roundedViolet,
  roundedVioletClosable,
  solidWhite,
};
